export enum SettingsEnum {
  BrandUsernameMinLength = 'brand.usernameMinLength',
  BrandUsernameMaxLength = 'brand.usernameMaxLength',
  PrivacyPolicyUrl = 'privacy-policy-url',
  CloseUrl = 'cancel-url',
  CancelUrl = 'cancel-url',
  BranchCancelUrl = 'branch-cancel-url',
  SuccessTrackingURL = "success-pixel-url",
  MaintenanceBanner = "maintenance-banner",
  AppStoreLink = "app-store-link",
  GooglePlayLink = "google-play-link",
  CreateCredentialsURL = "create-credentials-url",
  DefaultCancelUrl = "success-cancel-url",
  DefaultBaskCancelUrl = "bask-code-verification-cancel-url",
  EnableJointOwnerAuthenticatedFlow = "feature.authenticated_flow.enable_joint_owner",
  AuthenticatedFlowNextSteps = "authenticated_flow.success_next_steps",
  AuthenticatedFlowJointOwnerFeatureDisabledText = "authenticated_flow.joint_owner_disabled_text",
  DirectDepositFeatureText = "direct-deposit.text",
  AccountRestrictionsText = "account-restrictions-text",
  RatesFeesLink = "rates-fees-link",
  ProductStripeColor = "product-stripe-color",
  FDICImgDesktop = "fdic-desktop-image",
  FDICImgMobile = "fdic-mobile-image",
  FDICAltText = "fdic-image-alt-text"
}
